<article class="page-container flex flex-column">
  <p-accordion styleClass="hide-from-small pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
    collapseIcon="far fa-eye-slash">
    <p-accordionTab class="m-0" [header]="screen.labels.filters">
      <label for="dtMobileNameFilter">{{screen.labels.name}}</label>
      <input pInputText type="text" [style.width]="'100%'" name="dtMobileNameFilter" [(ngModel)]="dtNameFilter"
        (input)="dt.filter(dtNameFilter, 'name', 'contains')">
    </p-accordionTab>
  </p-accordion>

  <div class="inline-flex">
    <p-table #dt [value]="catalogs" [paginator]="true" [rows]="20" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="number" [style.width.px]="50">
          <col data-id="status" [style.width.px]="50">
          <col data-id="id" [style.width.px]="175">
          <col data-id="name">
          <col data-id="user" [style.width.px]="175" class="hide-on-medium">
          <col data-id="date" [style.width.px]="125" class="hide-on-medium">
          <col data-id="action" [style.width.px]="75">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th colspan="2" rowspan="2"></th>
          <th rowspan="2">{{screen.labels.code}}</th>
          <th>{{screen.labels.name}}</th>
          <th colspan="2" class="text-center hide-on-medium">{{screen.labels.update}}</th>
          <th rowspan="2"></th>
        </tr>
        <tr>
          <th>
            <input pInputText type="text" [style.width]="'100%'" name="nameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'name', 'contains')">
          </th>
          <th class="hide-on-medium">{{screen.labels.user}}</th>
          <th class="hide-on-medium">{{screen.labels.date}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-catalog let-rowIndex="rowIndex">
        <tr>
          <td class="text-right hide-on-small">{{rowIndex + 1}}</td>
          <td class="text-center hide-on-small">
            <i class="fas fa-circle" [class.text-success]="catalog.status" [class.text-danger]="!catalog.status"
              [pTooltip]="catalog.status ? screen.labels.enabled : screen.labels.disabled"></i>
          </td>
          <td>
            <div class="inline-flex align-items-center">
              <i class="fas fa-circle hide-from-small mr-2" [class.text-success]="catalog.status"
                [class.text-danger]="!catalog.status"
                [pTooltip]="catalog.status ? screen.labels.enabled : screen.labels.disabled"></i>
              <span>{{catalog.id}}</span>
            </div>
          </td>
          <td>{{catalog.name}}</td>
          <td class="hide-on-medium">{{catalog.user}}</td>
          <td class="text-right hide-on-medium">{{catalog.date | date:'dd-MM-yyyy'}}</td>
          <td class="text-center">
            <button pButton class="p-button-info p-button-outlined" icon="fas fa-arrow-right"
              [routerLink]="[ '/admin/sistema/catalogo/' + catalog.id ]">
            </button>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</article>